module.exports = __webpack_public_path__ + "img/Therapierad.483e167a.jpg";